import { render } from "./index.vue?vue&type=template&id=1434900b&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1434900b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1434900b"

export default script